import { useParams } from 'next/navigation';
import usePaginatedOfferingUpdatesService from 'hooks/usePaginatedOfferingUpdatesService';

const useGetLatestUpdate = () => {
  const param = useParams();

  const { data: paginatedOfferingUpdatesService } = usePaginatedOfferingUpdatesService({
    recentlyApproved: true,
    slug: param?.slug?.[0],
  });

  const latestUpdate = paginatedOfferingUpdatesService?.pages?.flatMap((page) => page?.list?.[0]);

  return {
    latestUpdate,
  };
};

export default useGetLatestUpdate;
